import React from "react";
import EasyApplyIcon from '@job-facets/Icons/easyApplyIcon';
import { __ } from '@wordpress/i18n';

export default function EasyApplyView() {   
    return (
        <>
            <div className="c-job-card__posted-date ss-copy-small d-flex gap-5">
                <EasyApplyIcon />
                <span>{__('Easy apply', 'job')}</span>
            </div>
        </>
    )
}
